import { ActionTypes } from "store/constants";

export const setWorksheetView = (returnPayload) => ({
    type: ActionTypes.worksheetView.set_worksheetView,
    payload: returnPayload,
});